<template>
  <a
    id="container-weswap"
    class="container-banner container-weswap no-gutters tAc"
    rel="noreferrer"
    :class="{ home: home }"
  >
    <div class="posR container-mobile-img" />

    <div class="container-text">
      <p class="title" v-html="$t('wegow.banner.weswap.title')" />
    </div>
    <div class="sell">
      <wegow-button
        button-id="weswap-button"
        background="opacity"
        :text="$t('wegow.banner.weswap.sellTicket')"
        color="topaz-light"
        type="button"
        size="banner-xxl"
        @click="navigateToLanding"
      />
    </div>
  </a>
</template>

<script setup>
import WegowButton from "@/components/general/forms/WegowButton";
import { useUser } from "@/composables/useUser";
import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";

const props = defineProps({
  home: {
    type: Boolean,
    default: false
  }
});
const { userDetail, isAuth } = useUser();
const router = useRouter();
const route = useRoute();

const getRegion = computed(() => {
  return route.params.region || userDetail.value.region || "es";
});
const navigateToLanding = () => {
  if (isAuth.value && getRegion.value !== "mx") {
    router.push({ name: "MyWeswapPage" });
  } else {
    window.open("https://bit.ly/3otjC0Z", "_blank");
  }
};
</script>

<style lang="scss" scoped>
.container-weswap {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 250px;
  background-image: linear-gradient(#00000040, #00000040),
    url("@/assets/images/BANNER-WESWAP.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  cursor: default !important;
  @media screen and (max-width: $screen-lg) {
    height: 128px;
    gap: 11px;
  }
  .container-mobile-img {
    width: 107px;
    height: 19px;
    background-image: url("@/assets/images/logo_weswap.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    @media screen and (min-width: $screen-lg) {
      width: 264px;
      height: 47px;
      margin-bottom: 0.8rem;
    }
  }
  .flex-container {
    display: flex;
    @media screen and (max-width: 992px) {
      flex-direction: column;
    }
  }
  .sell {
    display: flex;
    justify-content: center;
    align-items: center;
    .sell-icon {
      width: 150px;
      height: 48px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      margin: 0 10px;
      background-image: url("@/assets/images/ic-sell-button.png");
      cursor: pointer;
    }
  }
}

.no-webp {
  .container-weswap {
    background-image: linear-gradient(#00000040, #00000040),
      url("@/assets/images/BANNER-WESWAP_2048x200.webp");
    .container-mobile-img {
      background-image: url("@/assets/images/logo-weswap.png");
    }
  }
}
.title {
  font-size: 0.75rem; // 12px
  font-weight: 600;
  text-align: center;
  line-height: normal;
  @media screen and (min-width: $screen-lg) {
    font-size: 1.875rem; // 30px
    font-weight: 600;
    margin-bottom: 2rem;
  }
}
</style>
